import { PlaidLinkType } from '@egw/api'
import { Spinner } from '@egw/components'
import { useTranslation } from '@egw/i18n'
import { ChevronRightIcon } from '@heroicons/react/24/outline'
import { type FC } from 'react'
import { type AccountSelectionProps } from '../../../types/plaid-multi-link'

/**
 * Button configuration interface for account type selection
 */
interface AccountTypeButton {
  linkType: PlaidLinkType
  translationKey: string
  testId: string
}



/**
 * Account type selection component for Plaid Multi Link flow
 */
export const AccountSelection: FC<AccountSelectionProps> = ({
  isCreatingPlaidMultiLinkToken,
  selectedLinkType,
  onAccountTypeSelection,
}) => {
  const { t } = useTranslation('features-external-accounts')

  // Account type button configuration
  const accountTypeButtons: AccountTypeButton[] = [
    {
      linkType: PlaidLinkType.BANKING,
      translationKey: 'plaid_multi_link.banking_button',
      testId: 'plaid-multi-link-banking-button',
    },
    {
      linkType: PlaidLinkType.INVESTMENTS,
      translationKey: 'plaid_multi_link.investments_button',
      testId: 'plaid-multi-link-investments-button',
    },
  ]

  return (
    <div
      className="flex flex-col"
      data-testid="plaid-multi-link-account-selection"
      role="form"
      aria-labelledby="account-selection-title"
    >
      {accountTypeButtons.map((button) => (
        <button
          key={button.linkType}
          type="button"
          data-testid={button.testId}
          disabled={isCreatingPlaidMultiLinkToken}
          className={`w-full text-body flex items-center justify-between py-4 px-2 text-base border-list ${isCreatingPlaidMultiLinkToken ? 'opacity-50 cursor-not-allowed' : 'hover:bg-gray-50'}`}
          onClick={() => {
            onAccountTypeSelection(button.linkType)
          }}
          aria-describedby={`${button.linkType}-description`}
        >
          <span>{t(button.translationKey)}</span>
          {isCreatingPlaidMultiLinkToken && selectedLinkType === button.linkType ? (
            <div className="flex items-center gap-2">
              <Spinner className="fill-icons-meta" />
            </div>
          ) : (
            <ChevronRightIcon className="text-text-meta w-5 h-5" />
          )}
        </button>
      ))}
    </div>
  )
}
